<template>
    <div>
        <div class="heading">
            <legend>
                <span class="legend-text">
                    {{ label }}
                </span>
            </legend>
        </div>
        <div class="input">
            <label v-for="option in options" :key="option.value">
                <input type="checkbox" :value="option.value" :checked="isChecked(option.value)" @change="updateValues($event.target.checked, $event.target.value)">
                <span />
                <em v-html="option.label" />
            </label>
        </div>
        <p v-if="v && v.$error" class="error text--orange small semi">
            This field is required
        </p>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: null,
        },
        value: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Array,
            default: () => [],
        },
        v: {
            type: Object,
            default: null,
        }
    },

    methods: {
        updateValues(add, value) {
            const result = add ? [...this.value, value] : [...this.value.filter((o) => o != value)];
            this.$emit('input', result);
        },

        isChecked(value) {
            return this.value.find((o) => o == value);
        }
    }
};
</script>

<style lang="scss" scoped>
    .checkboxes--inline {
        label {
            align-items: flex-start;
        }

        .input {
            span {
                top: 4px;
            }

            em {
                font-style: normal;
            }
        }
    }
</style>
